import React from "react";
import { useState , useEffect } from "react";
import { Accordion, Card, Tabs,Tab } from "react-bootstrap";
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";

const InstructorUploadedCode = ({code}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const [fileData, setFileData] = useState({});
  const [activeTab, setActiveTab] = useState("");
  useEffect(() => {
    const parsedFiles = parseCodeString(code);
    setFileData(parsedFiles);
    // Default to the first file
    setActiveTab(Object.keys(parsedFiles)[0] || "");
  }, [code]);

  // Function to parse the string into an object
  const parseCodeString = (codeString) => {
    const files = {};
    const fileSections = codeString.split(/File:\s+([^\n]+)\n/).slice(1); // Split by "File: <filename>"

    for (let i = 0; i < fileSections.length; i += 2) {
      const fileName = fileSections[i].trim();
      let fileContent = fileSections[i + 1]?.trim() || "";
      // fileContent = fileContent.replace(
      //   /(?<=\/\* --- Start of student code, Don't Remove or edit these markers --- \*\/)[\s\S]*?(?=(\s*)\/\* --- End of student code, Don't Remove or edit these markers --- \*\/)/g,
      //   (_, leadingSpaces) => "\n" + leadingSpaces // Maintain proper indentation
      // );
      
      files[fileName] = fileContent;  
    }
    return files;
  };

  const highlightedCode = (fileContent) => {
    return fileContent.split("\n").map((line, index) => {
      if (line.includes("/* --- Start of student code") || line.includes("/* --- End of student code")) {
        return (
          <span key={index} style={{ color: "red" }}>
            {line+'\n'}
          </span>
        );
      }
      return <span key={index}>{line+'\n'}</span>;
    });  
  } 

  return (
    <div style={{maxHeight:"500px"}}>
      {/* Accordion to display the problem statement */}
      <Accordion defaultActiveKey="0">
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Instructor Uploaded Code</div>
              <div>
                {isAccordionOpen ? (
                  <RiArrowDropDownLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                ) : (
                  <RiArrowDropRightLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                )}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse in={isAccordionOpen}>
            <Card.Body>
              {Object.keys(fileData).length > 0 ? (
                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                  {Object.entries(fileData).map(([fileName, fileContent]) => (
                    <Tab eventKey={fileName} title={fileName} key={fileName}>
                      <pre
                        style={{
                          backgroundColor: "#f5f5f5",
                          padding: "10px",
                          borderRadius: "5px",
                          whiteSpace: "pre-wrap",
                          overflowX: "auto",
                        }}
                      >
                        <code>{highlightedCode(fileContent)}</code>
                      </pre>
                    </Tab>
                  ))}
                </Tabs>
                ) : (
                  <p>No files available</p>
              )}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default InstructorUploadedCode;
